module.exports = __webpack_public_path__ + "img/chicago.de9d10a7.png";